"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { IRenewTotal } from "@/interfaces/renew.interfaces";
import renewService from "@/services/renew.service";
import { ByIdRequestProps, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetRenewTotalByIdReturn = RequestsBaseReturn<IRenewTotal | null>;
export type IdProps = ByIdRequestProps;

type UseSwrGetRenewTotalByIdParams = [string, number];

const useGetRenewTotalById = ({ _id }: IdProps): UseGetRenewTotalByIdReturn => {
  const fetcher = useSWR<IRenewTotal, Error, UseSwrGetRenewTotalByIdParams | null>(
    _id ? [SWR_KEYS.getRenewTotalById, _id] : null,
    ([, renewId]) => renewService.getById(renewId),
    { revalidateOnFocus: false }
  );

  const { data = null, isValidating: isLoading, error } = fetcher;

  return { data, isLoading, error };
};

export default useGetRenewTotalById;
